import React from 'react';

/*
 * The Zenbul mark — an ensō, the Zen circle drawn in a single breath, left open.
 *
 * Rendered from public/mark.svg via <img> rather than inlined: it's a separate
 * cached request instead of path data in the JS bundle, and being one flat
 * vermilion fill it needs no per-theme recoloring — the same file reads on paper
 * and on the ink footer.
 */

const MARK_SRC = process.env.PUBLIC_URL + '/mark.svg';

function Mark({ size = 40, className }) {
  return (
    <img
      src={MARK_SRC}
      width={size}
      height={size}
      className={className}
      alt=""
      aria-hidden="true"
      style={{ display: 'block', flex: 'none' }}
    />
  );
}

export default Mark;
